module.exports = __webpack_public_path__ + "lendingcircles/resource/App/static/img/my-maf-app.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/my-maf-app.png
// module id = Wu6w
// module chunks = 1